
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DealerCreateModal from "./dealer_create_modal.vue"
import UserLogModal from "./user_log_modal.vue"
import UserSessionsModal from "./user_sessions_modal.vue"
import abilityModal from "../dealer/abilities.vue";

import Datatable from '@/components/Datatable'
import datatableMixin from '@/helpers/mixins/datatableMixin'

export default {
  mixins: [datatableMixin],
  page: {
    title: "Kullanıcı Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DealerCreateModal,
    UserLogModal,
    UserSessionsModal,
    Datatable,
    abilityModal
  },
  data() {
    return {
        list: {},
        title: "KULLANICI LİSTESİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "KULLANICI LİSTESİ",
            active: true,
          },
        ],
        columns: [
          { name: '', key: 'action', orderable: false, width:10  },
          { name: 'Online', key: 'online',  orderable: true, width: 350},
          { name: 'Kullanıcı Tipi', key: 'type_format', width: 150 },
          { name: 'Aktif', key: 'status', width: 150 },
          { name: 'İsim Soyisim', key: 'name', className: 'text-end', width: 150  },
          { name: 'Kullanıcı Adı', key: 'username', className: 'text-end', width: 150  },
        ],
        tableData: {
          detail: false,
          excel: false,
          searchable:{
            visible:true,
            placeholder:"Kullanıcı Adı, İsim Soyisim'de Ara"
          }
        },
        endpoint: '/users',
    };
  },

  methods: {
    async loadPage() {

      this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true

      try {
        const response = await  this.$http.post(this.endpoint, { params: this.params, sort_column:this.sortColumn, sort_crder:this.sortOrder, search_query: this.searchQuery });

        if (this.params.page === 1) {
          this.tableData.data = response.data.data;
        } else {
          this.tableData.data = [...this.tableData.data, ...response.data.data];
        }

        this.tableData.pagination = response.data.meta;

        this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false

      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Veri yüklenirken bir hata oluştu:", error);
        this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
      }
    },

  create(){
       this.list = {}
       this.$parent.$bvModal.show('modal-scoped')
    },

    update(props){
       const { ablty, id, name, password, type, username, sub_type, status } = props
       this.list = {  ablty, id, name, password, type, username, sub_type, status  }
       this.$parent.$bvModal.show('modal-scoped')
    },

    log(props){
       this.list = props
       this.$parent.$bvModal.show('modal-log')
    },

    ability(props){
      this.list = props
      this.$parent.$bvModal.show('modal-ability')
    },
    sessions(props){
      this.list = props
      this.$parent.$bvModal.show('modal-sessions')
    },

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <dealer-create-modal :list="list" @loadItems="reLoadPage"/>
    <user-log-modal :list="list" />
    <user-sessions-modal :list="list" />
    <ability-modal :list="list"/>
    <div class="row">
      <div class="col-12">
        <Datatable
            :columns="columns"
            :tableData="tableData"
            @sort-column="handleSortColumn"
            @search-query="reLoadPage"
            :loading="isLoading"
            :poading="pageLoading">

          <template #online="{ row }">
            <span v-if="row.tokens.length > 0"><strong>{{row.tokens.length}}</strong>  cihaz ile online</span>
            <span v-else-if="row.user_auth_logs">{{ row.user_auth_logs.created_at }}</span>
            <span v-else> - </span>
          </template>

          <template #button>
            <button class="btn btn-sm btn-success" @click="create()">Yeni Oluştur</button>
          </template>

          <template #status="{ row }">
            <span v-if="row.status == 1"  class="badge rounded-pill bg-success"><i class="fa fa-check"></i> Aktif </span>
            <span v-else  class="badge rounded-pill bg-danger"><i class="fa fa-times"></i> Pasif </span>
          </template>

          <template #action="{ row }">
            <b-dropdown
                toggle-class="font-size-16 p-0"
                toggle-tag="a"
                variant="white"
                append-to-body
                >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item @click="ability(row)">Yetkileri</b-dropdown-item>
                  <b-dropdown-item @click="update(row)">Güncelle</b-dropdown-item>
                    <b-dropdown-item @click="log(row)">Giriş Logları</b-dropdown-item>
                    <b-dropdown-item @click="sessions(row)">Açık Oturumlar</b-dropdown-item>
              </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>